/** Wire-contract names shared with the config API and Auth -- don't rename casually. */
export const KdsActionId = {
  AddKdsOrders: 'AddKdsOrders',
  SetDepartmentAvailability: 'SetDepartmentAvailability',
  AdjustDepartmentPrepTime: 'AdjustDepartmentPrepTime',
  EditItemAvailability: 'EditItemAvailability',
  CancelCustomerOrders: 'CancelCustomerOrders',
  LockKds: 'LockKds',
} as const

export type KdsActionId = (typeof KdsActionId)[keyof typeof KdsActionId]

const ALL_ACTION_IDS: readonly string[] = Object.values(KdsActionId)

export function toActionIds(values: readonly string[] | undefined): KdsActionId[] {
  if (!values) return []
  return values.filter((value): value is KdsActionId => ALL_ACTION_IDS.includes(value))
}

/**
 * An action listed in `elevatedActions` but not `availableActions` is invalid;
 * `normalizeKdsConfig` treats it as unavailable rather than trusting it.
 */
export type KdsActionPolicy = {
  availableActions: readonly KdsActionId[]
  elevatedActions: readonly KdsActionId[]
}

/**
 * Raw `/kds/orders/config` permission fields. `permissions`/`elevatedPermissions` are gated by
 * `userControlsLabEnabled` (the `KdsUserControls` lab) rather than by their own presence, since
 * a department can be sent empty arrays before its permissions are configured. The boolean pair
 * is a fallback for environments that haven't shipped the lab yet -- delete once none remain.
 */
export type KdsConfigPermissionsResponse = {
  userControlsLabEnabled?: boolean
  permissions?: readonly string[]
  elevatedPermissions?: readonly string[]
  canSetDepartmentAvailability?: boolean
  canAdjustDepartmentPrepTime?: boolean
  canAddKdsOrders?: boolean
}
